import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Public marketing and inquiry routes only. Never record admin, account,
// cart, checkout or private pages. This fires once per SPA path change.
export const PUBLIC_ANALYTICS_PATHS = new Set([
  "/", "/gallery", "/what-we-make", "/process",
  "/quote", "/events", "/contact", "/faq",
]);

export default function AnalyticsRouteTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    const safePath = pathname.replace(/\/$/, "") || "/";
    if (!PUBLIC_ANALYTICS_PATHS.has(safePath)) return;
    if (typeof window === "undefined" || !window.posthog?.capture) return;
    // No query string, hash, product customization or customer details.
    window.posthog.capture("$pageview", {
      site: "bbw_public",
      $current_url: window.location.origin + safePath,
    });
  }, [pathname]);

  return null;
}
